import { getTikTokPostMeta } from 'utils/api/tiktok.api';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

/**
 * Hook to fetch a TikTok post's cover thumbnail URL
 * @param {string} url - TikTok post URL
 * @returns {object} - { thumbnailUrl, isLoading, isError }
 */
export function useTikTokThumbnail(url) {
    const postId = url?.match(/\/(?:video|photo)\/(\d+)/)?.[1];

    const queryFn = useCallback(() => getTikTokPostMeta(postId), [postId]);

    const postMetaQuery = useQuery({
        queryKey: ['tiktok-post-meta', postId],
        queryFn,
        enabled: !!postId,
        // Must stay well inside the ~2-day expiry signed into the cover URL.
        cacheTime: 6 * 60 * 60 * 1000,
        staleTime: 6 * 60 * 60 * 1000,
        retry: (failureCount, error) => {
            if (error?.status === 404) return false;
            return failureCount < 2;
        },
    });

    return {
        thumbnailUrl: postMetaQuery.data?.thumbnail_url,
        isLoading: postMetaQuery.isLoading,
        isError: postMetaQuery.isError,
    };
}

export default useTikTokThumbnail;
